// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"564":"db676b5b","2260":"895dfff6","2519":"62123b44","3503":"8f753946"}[chunkId] + ".chunk.css";
};